import React, { useState } from 'react';
import { ArrowButtonProps } from './ArrowButton.model';
import * as S from './ArrowButton.styles';

export const ArrowButton = (props: ArrowButtonProps) => {
  const [isTouchStart, setIsTouchStart] = useState(false);

  const handleToggle = () => setIsTouchStart((prev) => !prev);

  return (
    <S.PaginationIcon
      {...props}
      isTouchStart={isTouchStart}
      onTouchStart={handleToggle}
      onTouchEnd={handleToggle}
    />
  );
};
